/**
 * Picks v2 or v1 of the Captions Translation page based on the
 * redesign flag.
 */
import React from 'react';
import { useRedesignFlag } from '../../../utils/redesignFlag';
import CaptionsTranslationPage   from './CaptionsTranslationPage';
import CaptionsTranslationPageV2 from './CaptionsTranslationPageV2';

export default function CaptionsTranslationPageSwitch(props) {
  const [v2] = useRedesignFlag();
  const Component = v2 ? CaptionsTranslationPageV2 : CaptionsTranslationPage;
  return <Component {...props} />;
}
